import { isAbsolute, join } from 'path';
export async function loadFromModuleExportExpression(expression, options) {
    if (typeof expression !== 'string') {
        return expression;
    }
    const { defaultExportName, cwd } = options || {};
    const [modulePath, exportName = defaultExportName] = expression.split('#');
    const mod = await tryImport(modulePath, cwd);
    if (exportName === 'default' || !exportName) {
        return mod.default || mod;
    }
    else {
        return mod[exportName] || (mod.default && mod.default[exportName]);
    }
}
async function tryImport(modulePath, cwd) {
    try {
        return await import(modulePath);
    }
    catch (e1) {
        if (!isAbsolute(modulePath)) {
            try {
                const absoluteModulePath = isAbsolute(modulePath) ? modulePath : join(cwd || process.cwd(), modulePath);
                return await import(absoluteModulePath);
            }
            catch (e2) {
                if (e2.message.includes('Cannot find module')) {
                    throw e1;
                }
                else {
                    throw e2;
                }
            }
        }
        throw e1;
    }
}
export function loadFromModuleExportExpressionSync(expression, options) {
    if (typeof expression !== 'string') {
        return expression;
    }
    const { defaultExportName, cwd } = options || {};
    const [modulePath, exportName = defaultExportName] = expression.split('#');
    const mod = tryImportSync(modulePath, cwd);
    if (exportName === 'default' || !exportName) {
        return mod.default || mod;
    }
    else {
        return mod[exportName] || (mod.default && mod.default[exportName]);
    }
}
function tryImportSync(modulePath, cwd) {
    try {
        return require(modulePath);
    }
    catch (e1) {
        if (!isAbsolute(modulePath)) {
            try {
                const absoluteModulePath = isAbsolute(modulePath) ? modulePath : join(cwd || process.cwd(), modulePath);
                return require(absoluteModulePath);
            }
            catch (e2) {
                if (e2.message.includes('Cannot find module')) {
                    throw e1;
                }
                else {
                    throw e2;
                }
            }
        }
        throw e1;
    }
}
//# sourceMappingURL=load-from-module-export-expression.js.map